import { Injectable } from '@angular/core';
import { AccountApi, CardApi, GameDataApi } from '../../Api/services/custom';
import { Account, Card, GameData } from '../../Api/models';
import { LoopBackAuth } from '../../Api/services/core';
import { GameDataInternal } from '../../interfaces/cards.interface';
import * as moment from 'moment';
import { LogicService } from './logic.service';


@Injectable({
    providedIn: 'root'
})
export class SyncDataService {
    gameDataServer: GameData[] = [];
    cardsServer: Card[] = [];
    gameActive = true;
    accountInfor = new Account();

    constructor(private accountApi: AccountApi,
                private auth: LoopBackAuth,
                private logicService: LogicService,
                private gameDataApi: GameDataApi,
                private cardApi: CardApi) {

    }

    checkGameActivated(id: number) {
        return new Promise((resolve, reject) => {
            this.cardApi.validateCourse(id)
                .subscribe((card: Card) => {
                    if (card) {
                        // console.log('checkGameActivated', card);
                        resolve(card);
                    } else {
                        // console.log('checkGameActivated empty');
                        resolve('ok');
                    }
                }, error => {
                    console.log('checkGameActivated', error);
                    reject(error.message);
                });

        });
    }


    upDateAccountInfor(id: number) {
        return new Promise(((resolve, reject) => {
            const filter = {
                include: [
                    {
                        relation: 'cards',
                        scope: {
                            order: 'activedAt ASC'
                        }
                    }]
            };
            this.accountApi.findById(id, filter)
                .subscribe((acc: Account) => {
                    if (acc && acc.id && acc.cards && acc.cards.length > 0) {
                        this.accountInfor = acc;
                        const tmp = acc.cards.filter((it: Card) => it.courseId === 0 && moment(it.activedAt).add(it.days, 'day') >= moment());
                        if (tmp && tmp.length > 0) {
                            resolve(tmp);
                        } else {
                            console.log('No Card');
                            reject('No Card');
                        }
                    } else {
                        console.log('Account is empty card');
                        reject('Account is empty');
                    }
                }, error => {
                    console.log('Request Account error', error);
                    reject(error.message);
                });
        }));
    }

    getCardList() {
        return this.cardsServer;
    }

    getGameActive() {
        return this.gameActive;
    }

    getGameDataOnline(id: number) {
        return new Promise(((resolve, reject) => {
            this.gameDataServer = [];
            this.gameDataApi.find({
                where: {
                    accountId: id
                }
            }).subscribe((gamesData: GameData[]) => {
                if (gamesData && gamesData.length > 0) {
                    this.gameDataServer = gamesData;
                    console.log('getGameDataOnline Success');
                    resolve(gamesData);
                } else {
                    this.gameDataServer = [];
                    console.log('getGameDataOnline empty');
                    resolve('ok');
                }
            }, error => {
                this.gameDataServer = [];
                console.log('getGameDataOnline', error);
                resolve('ok');
            });
        }));
    }

    // saveGameDataOnline(data: GameData) {
    //     return new Promise((resolve, reject) => {
    //         this.gameDataApi.patchAttributes(data.id, data)
    //             .subscribe(() => {
    //                 resolve('ok');
    //             }, error => {
    //                 console.log('saveGameDataOnline', error);
    //                 reject();
    //             });
    //     });
    // }

    getDataCurrent(address: string) {
        return new Promise((resolve, reject) => {
            this.logicService.getGameData(address).then((val: GameDataInternal) => {
                const result = this.syncGameData(val, address);
                if (result) {
                    resolve(result);
                } else {
                    resolve('ok');
                }
            }).catch(e => {
                console.log('getDataCurrent', e);
                reject();
            });
        });
    }

    syncGameData(dataOffline: GameDataInternal, address: string) {
        if (this.auth.getCurrentUserId()) {
            let dataOnline = new GameData();
            if (this.gameDataServer && this.gameDataServer.length > 0) {
                const tmp = this.gameDataServer.find(it => it.gameAddress === address);
                if (tmp) {
                    dataOnline = tmp;
                }
                // console.log('Find Game Data Online', dataOnline);
            }
            if (dataOnline && dataOnline.id) {
                if (dataOffline && dataOffline.currentLevel && (moment(dataOnline.updatedAt) < moment(dataOffline.updatedAt))) {
                    dataOnline.currentLevel = dataOffline.currentLevel;
                    dataOnline.gameAddress = dataOffline.gameAddress;
                    this.gameDataApi.patchAttributes(dataOnline.id, dataOnline)
                        .subscribe(() => {
                            // console.log('Update data success');
                        }, error => {
                            console.log('Update data error', error);
                        });
                } else {
                    const tmpData: GameDataInternal = {
                        currentLevel: dataOnline.currentLevel,
                        gameAddress: dataOnline.gameAddress,
                        updatedAt: moment()
                    };
                    dataOffline = tmpData;
                }
            } else {
                if (dataOffline && dataOffline.currentLevel && dataOffline.gameAddress) {
                    dataOnline.currentLevel = dataOffline.currentLevel;
                    dataOnline.gameAddress = dataOffline.gameAddress;
                    dataOnline.accountId = this.auth.getCurrentUserId();
                    this.gameDataApi.create(dataOnline)
                        .subscribe((gameData: GameData) => {
                            if (gameData && gameData.id) {
                                this.gameDataServer.push(gameData);
                            }
                            // console.log('Create data success');
                        }, error => {
                            console.log('Create data error', error);
                        });
                }
            }
        }
        this.logicService.setGameData(dataOffline);
        return dataOffline ? dataOffline : '';
    }
}
